





















import { defineComponent, PropType } from '@vue/composition-api';
import SelectButton from '@front-app/components/buttons/SelectButton.vue';
import { ButtonNavButton } from './buttonNav';

export default defineComponent({
	components: {
		SelectButton,
	},
	props: {
		selectedKey: {
			default: '',
			type: String,
		},
		buttons: {
			required: true,
			type: Array as PropType<ButtonNavButton[]>,
		},
	},
	setup() {
		return {};
	},
});
